// extracted by mini-css-extract-plugin
module.exports = {"header":"src_header__1yI0T","root":"src_root__3RoIn","app":"src_app__35rlJ"};